/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createStationComment } from '../fn/station/create-station-comment';
import { CreateStationComment$Params } from '../fn/station/create-station-comment';
import { DailyAvailabilitiesDurationsList } from '../models/daily-availabilities-durations-list';
import { deleteStationComment } from '../fn/station/delete-station-comment';
import { DeleteStationComment$Params } from '../fn/station/delete-station-comment';
import { getAllConnectivityStationGnv } from '../fn/station/get-all-connectivity-station-gnv';
import { GetAllConnectivityStationGnv$Params } from '../fn/station/get-all-connectivity-station-gnv';
import { getAvailabilitiesDurations } from '../fn/station/get-availabilities-durations';
import { GetAvailabilitiesDurations$Params } from '../fn/station/get-availabilities-durations';
import { getMonitoredStations } from '../fn/station/get-monitored-stations';
import { GetMonitoredStations$Params } from '../fn/station/get-monitored-stations';
import { getOpcuaCommunicationStates } from '../fn/station/get-opcua-communication-states';
import { GetOpcuaCommunicationStates$Params } from '../fn/station/get-opcua-communication-states';
import { getStationComments } from '../fn/station/get-station-comments';
import { GetStationComments$Params } from '../fn/station/get-station-comments';
import { getStationDailyAvailabilitiesDurations } from '../fn/station/get-station-daily-availabilities-durations';
import { GetStationDailyAvailabilitiesDurations$Params } from '../fn/station/get-station-daily-availabilities-durations';
import { MonitoredStations } from '../models/monitored-stations';
import { searchStationsCustom } from '../fn/station/search-stations-custom';
import { SearchStationsCustom$Params } from '../fn/station/search-stations-custom';
import { searchStationsSimplify$Any } from '../fn/station/search-stations-simplify-any';
import { SearchStationsSimplify$Any$Params } from '../fn/station/search-stations-simplify-any';
import { searchStationsSimplify$Json } from '../fn/station/search-stations-simplify-json';
import { SearchStationsSimplify$Json$Params } from '../fn/station/search-stations-simplify-json';
import { StationAvailabilitiesDurationsList } from '../models/station-availabilities-durations-list';
import { StationCommentList } from '../models/station-comment-list';
import { StationGnvConnectivityPagedList } from '../models/station-gnv-connectivity-paged-list';
import { StationGnvPagedList } from '../models/station-gnv-paged-list';
import { StationGnvSimplePagedList } from '../models/station-gnv-simple-paged-list';
import { StationOpcuaCommunicationStates } from '../models/station-opcua-communication-states';
import { updateMonitoredStations } from '../fn/station/update-monitored-stations';
import { UpdateMonitoredStations$Params } from '../fn/station/update-monitored-stations';


/**
 * All about the stations
 */
@Injectable({ providedIn: 'root' })
export class StationService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMonitoredStations()` */
  static readonly GetMonitoredStationsPath = '/custom/stations/monitored';

  /**
   * Provide informations and states about OPCUA communications for a given station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMonitoredStations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMonitoredStations$Response(params?: GetMonitoredStations$Params, context?: HttpContext): Observable<StrictHttpResponse<MonitoredStations>> {
    return getMonitoredStations(this.http, this.rootUrl, params, context);
  }

  /**
   * Provide informations and states about OPCUA communications for a given station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMonitoredStations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMonitoredStations(params?: GetMonitoredStations$Params, context?: HttpContext): Observable<MonitoredStations> {
    return this.getMonitoredStations$Response(params, context).pipe(
      map((r: StrictHttpResponse<MonitoredStations>): MonitoredStations => r.body)
    );
  }

  /** Path part for operation `updateMonitoredStations()` */
  static readonly UpdateMonitoredStationsPath = '/custom/stations/monitored';

  /**
   * Update the list of monitored station .
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMonitoredStations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMonitoredStations$Response(params: UpdateMonitoredStations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateMonitoredStations(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the list of monitored station .
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMonitoredStations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMonitoredStations(params: UpdateMonitoredStations$Params, context?: HttpContext): Observable<void> {
    return this.updateMonitoredStations$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOpcuaCommunicationStates()` */
  static readonly GetOpcuaCommunicationStatesPath = '/custom/stations/{uid}/opcua-communication-states';

  /**
   * Provide informations and states about OPCUA communications for a given station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOpcuaCommunicationStates()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpcuaCommunicationStates$Response(params: GetOpcuaCommunicationStates$Params, context?: HttpContext): Observable<StrictHttpResponse<StationOpcuaCommunicationStates>> {
    return getOpcuaCommunicationStates(this.http, this.rootUrl, params, context);
  }

  /**
   * Provide informations and states about OPCUA communications for a given station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOpcuaCommunicationStates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOpcuaCommunicationStates(params: GetOpcuaCommunicationStates$Params, context?: HttpContext): Observable<StationOpcuaCommunicationStates> {
    return this.getOpcuaCommunicationStates$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationOpcuaCommunicationStates>): StationOpcuaCommunicationStates => r.body)
    );
  }

  /** Path part for operation `getAvailabilitiesDurations()` */
  static readonly GetAvailabilitiesDurationsPath = '/custom/stations/availabilities/durations';

  /**
   * Provide the availability states duration of all stations for a given date
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAvailabilitiesDurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailabilitiesDurations$Response(params: GetAvailabilitiesDurations$Params, context?: HttpContext): Observable<StrictHttpResponse<StationAvailabilitiesDurationsList>> {
    return getAvailabilitiesDurations(this.http, this.rootUrl, params, context);
  }

  /**
   * Provide the availability states duration of all stations for a given date
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAvailabilitiesDurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAvailabilitiesDurations(params: GetAvailabilitiesDurations$Params, context?: HttpContext): Observable<StationAvailabilitiesDurationsList> {
    return this.getAvailabilitiesDurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationAvailabilitiesDurationsList>): StationAvailabilitiesDurationsList => r.body)
    );
  }

  /** Path part for operation `getStationDailyAvailabilitiesDurations()` */
  static readonly GetStationDailyAvailabilitiesDurationsPath = '/custom/stations/{uid}/availabilities/durations';

  /**
   * Provide the availability states duration of a station for a series of date between a start date and an (excluded) end date
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationDailyAvailabilitiesDurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationDailyAvailabilitiesDurations$Response(params: GetStationDailyAvailabilitiesDurations$Params, context?: HttpContext): Observable<StrictHttpResponse<DailyAvailabilitiesDurationsList>> {
    return getStationDailyAvailabilitiesDurations(this.http, this.rootUrl, params, context);
  }

  /**
   * Provide the availability states duration of a station for a series of date between a start date and an (excluded) end date
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationDailyAvailabilitiesDurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationDailyAvailabilitiesDurations(params: GetStationDailyAvailabilitiesDurations$Params, context?: HttpContext): Observable<DailyAvailabilitiesDurationsList> {
    return this.getStationDailyAvailabilitiesDurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<DailyAvailabilitiesDurationsList>): DailyAvailabilitiesDurationsList => r.body)
    );
  }

  /** Path part for operation `searchStationsCustom()` */
  static readonly SearchStationsCustomPath = '/custom/stations/search';

  /**
   * Search stations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationsCustom()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchStationsCustom$Response(params?: SearchStationsCustom$Params, context?: HttpContext): Observable<StrictHttpResponse<StationGnvPagedList>> {
    return searchStationsCustom(this.http, this.rootUrl, params, context);
  }

  /**
   * Search stations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationsCustom$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchStationsCustom(params?: SearchStationsCustom$Params, context?: HttpContext): Observable<StationGnvPagedList> {
    return this.searchStationsCustom$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationGnvPagedList>): StationGnvPagedList => r.body)
    );
  }

  /** Path part for operation `searchStationsSimplify()` */
  static readonly SearchStationsSimplifyPath = '/custom/stations/simplify/search';

  /**
   * Search stations in a simplified form (uid, name, code, service).
   *
   * Lightweight station search meant to feed selectors/dropdowns, without loading the full station payload.
   * By default the caller filters on the in-use services; including STOPPED in `services` also returns stations
   * that are no longer in service, so their historical data (e.g. KPI) stays reachable.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationsSimplify$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationsSimplify$Json$Response(params?: SearchStationsSimplify$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StationGnvSimplePagedList>> {
    return searchStationsSimplify$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search stations in a simplified form (uid, name, code, service).
   *
   * Lightweight station search meant to feed selectors/dropdowns, without loading the full station payload.
   * By default the caller filters on the in-use services; including STOPPED in `services` also returns stations
   * that are no longer in service, so their historical data (e.g. KPI) stays reachable.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationsSimplify$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationsSimplify$Json(params?: SearchStationsSimplify$Json$Params, context?: HttpContext): Observable<StationGnvSimplePagedList> {
    return this.searchStationsSimplify$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationGnvSimplePagedList>): StationGnvSimplePagedList => r.body)
    );
  }

  /**
   * Search stations in a simplified form (uid, name, code, service).
   *
   * Lightweight station search meant to feed selectors/dropdowns, without loading the full station payload.
   * By default the caller filters on the in-use services; including STOPPED in `services` also returns stations
   * that are no longer in service, so their historical data (e.g. KPI) stays reachable.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationsSimplify$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchStationsSimplify$Any$Response(params?: SearchStationsSimplify$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<StationGnvSimplePagedList>> {
    return searchStationsSimplify$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search stations in a simplified form (uid, name, code, service).
   *
   * Lightweight station search meant to feed selectors/dropdowns, without loading the full station payload.
   * By default the caller filters on the in-use services; including STOPPED in `services` also returns stations
   * that are no longer in service, so their historical data (e.g. KPI) stays reachable.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationsSimplify$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchStationsSimplify$Any(params?: SearchStationsSimplify$Any$Params, context?: HttpContext): Observable<StationGnvSimplePagedList> {
    return this.searchStationsSimplify$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationGnvSimplePagedList>): StationGnvSimplePagedList => r.body)
    );
  }

  /** Path part for operation `getAllConnectivityStationGnv()` */
  static readonly GetAllConnectivityStationGnvPath = '/custom/stations-connectivity';

  /**
   * get all station connectivity.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllConnectivityStationGnv()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllConnectivityStationGnv$Response(params?: GetAllConnectivityStationGnv$Params, context?: HttpContext): Observable<StrictHttpResponse<StationGnvConnectivityPagedList>> {
    return getAllConnectivityStationGnv(this.http, this.rootUrl, params, context);
  }

  /**
   * get all station connectivity.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllConnectivityStationGnv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllConnectivityStationGnv(params?: GetAllConnectivityStationGnv$Params, context?: HttpContext): Observable<StationGnvConnectivityPagedList> {
    return this.getAllConnectivityStationGnv$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationGnvConnectivityPagedList>): StationGnvConnectivityPagedList => r.body)
    );
  }

  /** Path part for operation `getStationComments()` */
  static readonly GetStationCommentsPath = '/custom/stations/{uid}/comment';

  /**
   * Get the comments for a station.
   *
   * Allows to get the comments for a station.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationComments()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationComments$Response(params: GetStationComments$Params, context?: HttpContext): Observable<StrictHttpResponse<StationCommentList>> {
    return getStationComments(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the comments for a station.
   *
   * Allows to get the comments for a station.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationComments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationComments(params: GetStationComments$Params, context?: HttpContext): Observable<StationCommentList> {
    return this.getStationComments$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationCommentList>): StationCommentList => r.body)
    );
  }

  /** Path part for operation `createStationComment()` */
  static readonly CreateStationCommentPath = '/custom/stations/{uid}/comment';

  /**
   * Create comment for a station.
   *
   * Allows to create comment for a station.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createStationComment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStationComment$Response(params: CreateStationComment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createStationComment(this.http, this.rootUrl, params, context);
  }

  /**
   * Create comment for a station.
   *
   * Allows to create comment for a station.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createStationComment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStationComment(params: CreateStationComment$Params, context?: HttpContext): Observable<void> {
    return this.createStationComment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteStationComment()` */
  static readonly DeleteStationCommentPath = '/custom/stations/{uid}/comment';

  /**
   * Delete all comment for a station.
   *
   * Allows to delete comments for a station.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteStationComment()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStationComment$Response(params: DeleteStationComment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteStationComment(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete all comment for a station.
   *
   * Allows to delete comments for a station.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteStationComment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStationComment(params: DeleteStationComment$Params, context?: HttpContext): Observable<void> {
    return this.deleteStationComment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
